import { render, staticRenderFns } from "./BusinessOpportunitySelector.vue?vue&type=template&id=337d4494&"
import script from "./BusinessOpportunitySelector.vue?vue&type=script&lang=js&"
export * from "./BusinessOpportunitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports